import { apiClient } from '@/utils/api-client'

const API_INTERNAL_BASE = '/projects'

/**
 * Project service for managing projects.
 *
 * Provides CRUD operations for projects.
 */
class ProjectService {
    /**
     * Create a new project.
     *
     * @param {Object} form - Project data
     * @param {string} form.name - Project name
     * @param {string} form.key - Unique project key
     * @returns {Promise<Object>} Created project data
     * @throws {string} Error message if creation fails
     */
    async create(form) {
        return await apiClient
            .post(API_INTERNAL_BASE, form)
            .then((response) => {
                return response.data
            })
    }

    /**
     * Delete a project.
     *
     * @param {string} key - Project key to delete
     * @returns {Promise<Object>} Deletion confirmation
     * @throws {string} Error message if deletion fails
     */
    async remove(key) {
        return await apiClient
            .delete(API_INTERNAL_BASE + '/' + key)
            .then((response) => {
                return response.data
            })
    }

    /**
     * Get a single project by key.
     *
     * @param {string} key - Project key
     * @returns {Promise<Object>} Project data with environments and flags
     * @throws {string} Error message if project not found
     */
    async get(key) {
        return await apiClient
            .get(API_INTERNAL_BASE + '/' + key)
            .then((response) => {
                return response.data
            })
    }

    /**
     * Get all projects for the authenticated user.
     *
     * @returns {Promise<Array>} Array of project objects
     * @throws {string} Error message if request fails
     */
    async list() {
        return await apiClient.get(API_INTERNAL_BASE).then((response) => {
            return response.data
        })
    }

    /**
     * Update an existing project.
     *
     * @param {string} key - Project key to update
     * @param {Object} form - Updated project data
     * @returns {Promise<Object>} Updated project data
     * @throws {string} Error message if update fails
     */
    async update(key, form) {
        return await apiClient
            .put(API_INTERNAL_BASE + '/' + key, form)
            .then((response) => {
                return response.data
            })
    }
}

export default new ProjectService()
